module.exports = __webpack_public_path__ + "sock.jpg?616ee8d25c572265c903d7fecbcf5e76";